module.exports = __webpack_public_path__ + "static/media/49.982eaf9.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/49.wav
// module id = vQ+A
// module chunks = 0